import { Module, GetterTree, ActionTree, MutationTree } from 'vuex';
import { initialActions, initialMutations } from '.';
import _ from 'lodash';
import { TOURS } from '@/constants/tour';
import { readStepByStepGuidesFromLocalStorage } from '@/utils/localStorage';

interface TourState {
  name: string;
  steps: {
    target: string;
    content: string;
    params: Record<string, any>;
  }[];
}

const getInitialState = () => ({
  name: 'default',
  steps: [],
});

const state: TourState = {
  ...getInitialState(),
};

const getters: GetterTree<TourState, RootState> = {};

const actions: ActionTree<TourState, RootState> = {
  ...initialActions,
  start({ state, dispatch }, { tours, tourKey }) {
    const guides = readStepByStepGuidesFromLocalStorage();
    if (guides.includes(tourKey)) {
      return;
    }

    const { name, steps } = TOURS[tourKey];

    return Promise.all([
      dispatch('setState', { key: 'name', payload: name }),
      dispatch('setState', { key: 'steps', payload: steps }),
    ]).finally(() => {
      tours[state.name].start();
    });
  },
  stop({ state }, { tours }) {
    if (_.has(tours, state.name)) {
      tours[state.name].stop();
    }
  },
};

const mutations: MutationTree<TourState> = {
  ...initialMutations,
};

const tour: Module<TourState, RootState> = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

export default tour;
